import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Container from '@material-ui/core/Container';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import Toolbar from 'components/Layout/Toolbar';
import FabButton from 'components/Shared/FabButton';
import TableWrapper from 'components/Shared/TableWrapper';
import { IPaginationParams } from 'interfaces/pagination';
import { IVenture } from 'interfaces/venture';
import PlusIcon from 'mdi-react/PlusIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import React, { Fragment } from 'react';
import rxjsOperators from 'rxjs-operators';
import ventureService from 'services/venture';

import VentureFormDialog from '../VentureFormDialog';
import ListItem from './ListItem';

interface IState extends IStateList<IVenture> {
  current?: IVenture;
  formOpened?: boolean;
}

export default class VentureListPage extends ListComponent<{}, IState> {
  constructor(props: {}) {
    super(props, 'name');
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });

    ventureService.list(this.mergeParams(params)).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(items => {
      this.setPaginatedData(items);
    }, error => this.setError(error));
  }

  onClickRefresh = () => this.loadData();

  handleCreate = () => {
    this.setState({ formOpened: true, current: null });
  }

  handleEdit = (current: IVenture) => {
    this.setState({ formOpened: true, current });
  }

  handleView = (current: IVenture) => {
    this.setState({ current });
  }

  formCallback = (venture?: IVenture) => {
    this.setState({ formOpened: false });

    this.state.current ?
      this.loadData() :
      this.handleChangeTerm(venture.name);
  }

  formCancel = () => {
    this.setState({ formOpened: false });
  }

  render() {
    const { items, formOpened, loading, current } = this.state;

    return (
      <Fragment>
        <Toolbar title='Empreendimentos' breadcrumbs={[{ title: 'Configurações' }, { title: 'Empreendimentos' }]} />
        <VentureFormDialog
          opened={formOpened || false}
          venture={current}
          onComplete={this.formCallback}
          onCancel={this.formCancel}
        />
        <Container>
          <Card>
            {this.renderLoader()}
            <CardContent>
              <Grid container justify="space-between">
                <Grid item xs sm={8} lg={4}>
                  {this.renderSearch()}
                </Grid>
                <Grid item xs='auto'>
                  <FabButton actions={[{
                    icon: PlusIcon,
                    onClick: this.handleCreate
                  }]} />
                </Grid>
                <Grid item xs={12}>
                  <TableWrapper minWidth={500}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCellSortable {...this.sortableProps} column='name'>
                            Nome
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='cnpj'>
                            CNPJ
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='address'>
                            Endereço
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='uf'>
                            UF
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='city'>
                            Cidade
                          </TableCellSortable>
                          <TableCell>
                            <IconButton disabled={loading} onClick={this.onClickRefresh}>
                              <RefreshIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.renderEmptyAndErrorMessages(6)}
                        {items.map(venture =>
                          <ListItem
                            key={venture.id}
                            venture={venture}
                            onEdit={this.handleEdit}
                            onDeleteComplete={this.loadData}
                          />
                        )}
                      </TableBody>
                    </Table>
                  </TableWrapper>
                  {this.renderTablePagination()}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}